
<template>
  <!--社区app菜单-->
  <x-application></x-application>
</template>

<script>
export default {
  name: 'communityApp',
  data () {
    return {};
  },
  mounted () {},
  methods: {}
};
</script>
